import React from "react";
import { Link } from "react-scroll";
const Category = () => {
  const links = [
    {
      href: "founder",
      label: "Founder",
    },
    {
      href: "preschool",
      label: "PreSchool",
    },
    {
      href: "primary",
      label: "Primary",
    },
    {
      href: "secondary",
      label: "Secondary",
    },
    {
      href: "curricular",
      label: "Co-Curricular",
    },
    {
      href: "facilities",
      label: "Facilities",
    },
    {
      href: "instagram",
      label: "Instagram",
    },
  ];

  return (
    <div className="flex flex-wrap gap-4 justify-center py-10 fontstyle2 px-4">
      {links.map((data, id) => {
        return (
          <Link
            key={id}
            to={data.href}
            data-to-scrollspy-id={data.href}
            className="px-4 py-2 bg-slate-100 border-purple-400 border"
            smooth={true}
            duration={500}
          >
            {data.label}
          </Link>
        );
      })}
    </div>
  );
};

export default Category;
